module.exports = __webpack_public_path__ + "static/bagel@2x-c67967bb693b129a22770d38aaa298bf.webp";